import i18n from 'scoreboard/components/i18n'
import scoreboardUrl from 'scoreboard/components/scoreboard-url'

/**
 * Returns an HTML link to a screen like Admin | Databases
 */
function adminLink(path, labelKey) {
	return `<a class="sp-navigate text-link" href="${scoreboardUrl(adminRoute(path))}">` +
		i18n.get('admin.admin') + ' &gt; ' +
		i18n.get(labelKey) +
		'</a>'
}

function adminRoute (path) {
	return '/admin/' + path
}

function adminDatabasesLink() {
	return adminLink('scoreboard-databases', 'admin.licenses.usage.databases')
}

function adminTreesLink() {
	return adminLink('dataset-trees', 'datasets.dataType.rollupTrees')
}

function adminImportConnectionsLink() {
	return adminLink('import-connections', 'admin.importConnections')
}

function adminSharedDashboardsLink() {
	return adminLink('shared-dashboards', 'admin.sharedDashboards')
}

function adminSharedFormsLink() {
	return adminLink('shared-forms', 'admin.sharedForms')
}

function adminMassEditLink() {
	return adminLink('mass-edit', 'admin.massEdit')
}

function adminAppLink() {
	return adminLink('app', 'admin.appConfiguration.applicationConfiguration')
}

/**
 * Returns a full HTML link to the dataset rollup trees screen
 *
 * @param {Int} [treeId] if provided, a specific tree to navigate to
 */
function adminDatasetRollupTreesLink (treeId) {
	return adminLink(adminDatasetRollupTreesSubRoute(treeId),
		'datasets.dataType.rollupTrees')
}

/**
 * Returns the non-admin part of the rollup tree route; see
 * adminDatasetRollupTreesRoute() for the full route
 */
function adminDatasetRollupTreesSubRoute (treeId) {
	let path = 'dataset-trees'
	if (treeId) {
		path += '/' + treeId
	}
	return path
}

/**
 * Returns the route to the dataset rollup trees screen (eg what we'd pass to
 * the Backbone router)
 *
 * @param {Int} [treeId] if provided, a specific tree to navigate to
 */
function adminDatasetRollupTreesRoute (treeId) {
	return adminRoute(adminDatasetRollupTreesSubRoute(treeId))
}

export {
	adminDatabasesLink,
	adminTreesLink,
	adminImportConnectionsLink,
	adminSharedDashboardsLink,
	adminSharedFormsLink,
	adminMassEditLink,
	adminAppLink,
	adminDatasetRollupTreesLink,
	adminDatasetRollupTreesRoute
}
